import Button from 'blocks/Button';
import StatusText from 'blocks/StatusText';
import RouteFreeTicketDetail from 'components/FreeTicket/RouteDetail';
import BaseModal from 'components/modals/BaseModal';
import { Freeticket } from 'pages/miles/View/viwe.interface';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ContentProps } from './FreeTicketTransactionDetail.interface';
import * as S from './FreeTicketTransactionDetailModal.styles';

const Content = ({ open, closeModal, freeticket }: ContentProps) => {
  const FlightDetails = JSON.parse(freeticket?.bookRequest);
  const { t } = useTranslation();
  if (!freeticket) return null;

  return (
    <S.FlightDetailModal>
      <S.GrayCard>
        <RouteFreeTicketDetail freeTicket={freeticket} bookRequest={FlightDetails} showPNR />
      </S.GrayCard>

      <S.BtnContainer>
        <StatusText color={freeticket.status === 'init' ? 'warn' : freeticket.status === 'done' ? 'success' : 'error'}>
          {freeticket.status}
        </StatusText>

        <S.Btn as={Button} styleType="default" className="fs-xs" onClick={closeModal}>
          {t('pages.miles.view.modals.details.closeCTA')}
        </S.Btn>
      </S.BtnContainer>
    </S.FlightDetailModal>
  );
};

interface State {
  open: boolean;
  freeticket: Freeticket | null;
}

interface Props {
  ref: any;
}

class FreeTicketDetailTransactionModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      open: false,
      freeticket: null,
    };
  }

  openModal = (freeticket: Freeticket): void => this.setState({ open: true, freeticket });

  closeModal = (): void => this.setState({ open: false });

  render() {
    return (
      <S.FlightDetailModalContainer as={BaseModal} open={this.state.open} closeModal={this.closeModal}>
        {this.state.freeticket ? (
          <Content
            {...this.props}
            open={this.state.open}
            closeModal={this.closeModal}
            freeticket={this.state.freeticket}
          />
        ) : null}
      </S.FlightDetailModalContainer>
    );
  }
}

export default FreeTicketDetailTransactionModal;
